import script from "./ChangeRequestCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeRequestCard.vue?vue&type=script&setup=true&lang=js"

import "./ChangeRequestCard.vue?vue&type=style&index=0&id=60fcf037&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60fcf037"]])

export default __exports__